export enum Locales {
  en = 'en',
  ua = 'uk-UA',
}

// Sections aria-labelledby values
export enum SectionLabels {
  top = 'top-section',
  about = 'about-section',
  principles = 'principles-section',
  join = 'join-section',
  signatories = 'signatories-section',
  media = 'media-section',
  benefits = 'benefits-section',
}
